var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.925 9.46991H6.88053L9.95609 5.77891C10.2558 5.41997 10.2067 4.88579 9.84773 4.58695C9.48794 4.28727 8.9546 4.33637 8.65577 4.69531L4.42296 9.77467C4.38995 9.81446 4.37302 9.86102 4.34847 9.90505C4.32815 9.9406 4.3036 9.97108 4.28836 10.01C4.25027 10.1074 4.22741 10.2098 4.22741 10.3131C4.22741 10.3139 4.22656 10.3156 4.22656 10.3165C4.22656 10.3173 4.22741 10.319 4.22741 10.3199C4.22741 10.4231 4.25027 10.5256 4.28836 10.6229C4.3036 10.6619 4.32815 10.6923 4.34847 10.7279C4.37302 10.7719 4.38995 10.8185 4.42296 10.8583L8.65577 15.9376C8.82339 16.1383 9.06381 16.2424 9.30593 16.2424C9.49725 16.2424 9.68942 16.1781 9.84773 16.046C10.2067 15.7472 10.2558 15.213 9.95609 14.854L6.88053 11.163H16.925C17.3923 11.163 17.7715 10.7838 17.7715 10.3165C17.7715 9.84917 17.3923 9.46991 16.925 9.46991",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.610501e1ccc2ba911bc0d14d96cc1a7d.svg";
export { ForwardRef as ReactComponent };